import React, { Component } from 'react';
import Layout from '../../Layout/layout';
import { setLoadingPage, setErrorMessage } from '../../reducers/actions';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Button } from 'react-bootstrap';
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import { utcToLocal } from '../../utils/dateConvert'

class DeleteEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventDetails: [],
      name: "",
      description: "",
      type: "",
      configuration: "",
      status: "",
      name_error: false,
      type_error: false
    };
    this.formSubmit = false;
  }
  async componentDidMount() {
    let eventId = this.props.match.params.id;
    let selectUrl = `${apiHost}/api/Event/SelectedEvent/${eventId}`;
    this.postEventDetails(selectUrl);
  }

  postEventDetails = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      const eventDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      this.setState({ eventDetails: eventDetails.data });
      this.setState({
        name: eventDetails.data.name,
        description: eventDetails.data.description,
        type: eventDetails.data.type,
        Configuration: eventDetails.data.config,
        status: eventDetails.data.status,
      });
      console.log("eventDetails id", eventDetails.data);
      this.props.setLoadingPageAction(false);

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

  }

  deleteEvent = async () => {
    this.props.setLoadingPageAction(true);
    let eventId = this.props.match.params.id;
    try {
      await axios.get(
        `${apiHost}/api/Event/DeleteEvent/${eventId}`
        ,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );

      this.props.setLoadingPageAction(false);
      this.props.history.goBack();
      // this.props.history.push('/events')
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

  }

  render() {
    const { name, description, type, Configuration, status } = this.state;

    return (
      <div>
        <Layout>
          <Helmet>

            <title> Delete </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Delete</h2>
              <h1 style={{ fontSize: '24px' }}>Are you sure you want delete this?</h1>
              <h6>Event</h6>
              <hr></hr>
              <div className="eventsDetails">

                <div className="individualDetail">
                  <p className="left"> Type</p>
                  <p className="right">{type} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Configuration</p>
                  <p className="right">{Configuration} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Created</p>
                  <p className="right">{utcToLocal(this.state.eventDetails.dbCreated)} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Updated</p>
                  <p className="right">{utcToLocal(this.state.eventDetails.dbUpdated)} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Status</p>
                  <p className="right">{status == 0 ? 'Disabled' : 'Active'} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Name</p>
                  <p className="right">{name} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Description</p>
                  <p className="right">{description} </p>
                </div>
              </div>
              <br />
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    this.props.history.push("/events");
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button
                  size="sm"
                  variant="primary"
                  onClick={this.deleteEvent}
                >
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </Layout>



      </div>
    );
  }
}

const mapStateToProps = (state) => ({

  loading: state.loading

})
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage


}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEvent);
